// @react
import React, { useState, useEffect } from 'react'
import DocumentTitle from 'react-document-title'
// @common
import qs from 'qs'
// @components
import Container from '@bit/atd.web.container'
import Spacer from '@bit/atd.web.spacer'
import Search from 'modules/search/components/IndexMaster'
import { connectSearchBox, InstantSearch } from 'react-instantsearch-dom'
import SearchInput from 'modules/search/components/SearchInput'
import algoliasearch from 'algoliasearch'
import { contentTypes, ContentType } from 'constants/contentTypesMap'
import sortBy from 'modules/search/config/sortBy'
import { RouteComponentProps } from 'react-router-dom'
import Helper from 'utils/Helper.class'

const SearchBoxInput = connectSearchBox(SearchInput)

const searchStateToUrl = (props: any, searchState: any) =>
  searchState
    ? `${props.location.pathname}${Helper.createURL(searchState)}`
    : ''

const urlToSearchState = (location: any) => qs.parse(location.search.slice(1))
let debouncedSetState = 0

const searchClient = algoliasearch(
  process.env.REACT_APP_ALGOLIA_APP_ID as string,
  process.env.REACT_APP_ALGOLIA_SECRET as string,
)

/**
 * 4.0 MyATD - Benefits Center
 * https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=866%3A3045
 */

const title = 'Search'

const SearchWrapper: React.FunctionComponent<RouteComponentProps> = (
  props: RouteComponentProps,
) => {
  /******************************************
   * PROPS
   ******************************************/
  const {
    match: {
      // @ts-ignore
      params: { id = 'master' },
    },
    location,
  } = props

  const [index, setIndex] = useState(id)
  const baseIndex =
    sortBy.find((sortBy: any) =>
      sortBy.values.some((value: any) => value.value === index),
    )?.index || index
  const contentType = contentTypes.find(
    (contentType: ContentType) => contentType.index === baseIndex,
  )

  const getNewSearchState = (searchState: any): any => {
    const isExistMenuItem =
      searchState?.hierarchicalMenu &&
      searchState.hierarchicalMenu['contentTypes.lvl0']?.startsWith(
        contentType?.label,
      )

    const searchStateFromUrl = urlToSearchState(location)

    return isExistMenuItem
      ? searchStateFromUrl
      : {
          ...searchStateFromUrl,
          hierarchicalMenu: contentType
            ? { 'contentTypes.lvl0': contentType.label }
            : {},
        }
  }

  const [searchState, setSearchState] = useState<any>(
    getNewSearchState(urlToSearchState(location)),
  )
  const [lastLocation, setLastLocation] = useState(location)

  useEffect(() => {
    if (id !== index) {
      setIndex(id)
    }
  }, [id])

  useEffect(() => {
    if (location !== lastLocation) {
      setSearchState(getNewSearchState(urlToSearchState(location)))
      setLastLocation(location)
    }
  }, [location, lastLocation])

  const onSearchStateChange = (searchState: any) => {
    clearTimeout(debouncedSetState)
    const { configure, indices, ...restSearchState } = searchState
    // @ts-ignore
    debouncedSetState = setTimeout(() => {
      props.history.push(
        searchStateToUrl(props, restSearchState),
        restSearchState,
      )
    }, debouncedSetState)

    setSearchState(searchState)
  }

  return (
    <DocumentTitle title={`${title} | ATD`}>
      <>
        <InstantSearch
          searchClient={searchClient}
          indexName={index}
          searchState={searchState}
          onSearchStateChange={onSearchStateChange}
          createURL={Helper.createURL}
        >
          <SearchBoxInput index={index} />
          <Container>
            <Spacer size={20} />
            <Search baseIndex={baseIndex} index={index} />
          </Container>
        </InstantSearch>
      </>
    </DocumentTitle>
  )
}

export default SearchWrapper
